import React from 'react';
import { Check } from 'lucide-react';

const Process = ({ data }) => {
  return (
    <section id="process" className="py-24 bg-slate-950 relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-1/2 left-0 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl animate-pulse" />

      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            How It{' '}
            <span className="bg-gradient-to-r from-emerald-400 to-yellow-500 bg-clip-text text-transparent">
              Works
            </span>
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            A simple, streamlined process to bring your video ideas to life
          </p>
        </div>

        {/* Process Steps */}
        <div className="max-w-4xl mx-auto">
          {data.map((item, index) => {
            const delay = `delay-${index * 200}`;
            return (
              <div key={item.step} className={`relative animate-fade-in-left ${delay}`}>
                {/* Connecting Line */}
                {index < data.length - 1 && (
                  <div className="absolute left-6 md:left-8 top-16 bottom-0 w-0.5 bg-gradient-to-b from-emerald-500 to-emerald-500/20" />
                )}

                {/* Step Card */}
                <div className="flex gap-6 mb-12 group">
                  {/* Step Number */}
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 md:w-16 md:h-16 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 flex items-center justify-center shadow-lg shadow-emerald-500/30 group-hover:scale-110 group-hover:rotate-12 transition-all duration-500 relative z-10">
                      <span className="text-white font-bold text-xl md:text-2xl">{item.step}</span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1 pt-1">
                    <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800 rounded-2xl p-6 group-hover:border-emerald-500/50 transition-all duration-500 group-hover:shadow-lg group-hover:shadow-emerald-500/20 group-hover:-translate-x-2">
                      <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-emerald-400 transition-colors duration-300">
                        {item.title}
                      </h3>
                      <p className="text-slate-400 leading-relaxed">{item.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;